module.exports = __webpack_public_path__ + "img/stamp_toilet_off.0b28baa4.svg";